import { environment } from './../../../../environments/environment';
import { reportePosiciones } from './../../../_entities/coordenadas/ReportePosiciones';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AutosCamara } from './../../../_entities/autos/Autos';

@Injectable({
  providedIn: 'root'
})
export class HistorialVelocidadesVehiculoService {

  constructor(private http: HttpClient) { }

  graficarVelocidad(idVehiculo:number,fechaInicio:Date,fechaFinal:Date):Observable<reportePosiciones[]>{
    return this.http.get<reportePosiciones[]>(`${environment.API_SECURITY}/api/vehiculo/${idVehiculo}/reporte-historico?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`);

  }

  obtenerAutosCamara( pageNum, pageCount, beginTime, endTime, deviceID): Observable<any> {
	return this.http.get<any>(environment.API_SECURITY + '/api/Howen/device', {
		params: {
			pageNum,
			pageCount,
			beginTime,
			endTime,
			deviceID
		}
	})
}


}
